import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
    },
    leftContainer: {
        position: 'relative',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        width: '32%',
        height: '82vh',
        overflow: 'hidden',
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.06)",
        transition: "all 0.3s ease-in-out",
        marginTop:'30px',
        marginLeft:'20px',
        marginRight: '20px',
        backgroundColor: 'var(--brand-surface, #fff)',
        [theme.breakpoints.down('sm')]: {
            marginTop:'0',
            marginLeft:'0',
            width:'auto',
            flexDirection: 'column',
            transition: 'height 0.3s ease',
            position: 'relative',
            minHeight:'0px',
            overflow: 'hidden',
        },
    },
    embeddedLeftContainer: {
        position: 'relative',
        padding: '0px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '16px',
        width: '26%',
        height: '82vh',
        overflow: 'hidden',
        transition: "all 0.3s ease-in-out",
        marginTop:'20px',
        marginLeft:'20px',
        marginRight: '0px',
        backgroundColor: 'var(--brand-surface, #fff)',
        [theme.breakpoints.down('sm')]: {
            marginTop:'0',
            marginLeft:'0',
            width:'auto',
            flexDirection: 'column',
            transition: 'height 0.3s ease',
            position: 'relative',
            minHeight:'0px',
            overflow: 'hidden',
        },
    },

    leftContentContainer:{
        height: "100%",
        overflowY: "auto",
        paddingBottom: 56,
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#cfd6e4',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f3f5f9',
        },
    },

    rightContainer: {
        borderRadius: '8px',
        height:'82vh',
        overflow: 'hidden',
        overflowX: 'hidden',
        padding: '10px 0',
        width: '68%',
        display: 'flex',
        flexDirection: 'column',
        alignItems:'center',
        justifyContent:'flex-start',
        position:'relative',
        maxWidth: '100%',
        boxSizing: 'border-box',
        border: 'none',
        scrollbarGutter: 'stable both-edges',
        [theme.breakpoints.down('sm')]: {
            marginLeft:'0px',
            marginRight: '0px',
            width:'auto',
            padding: '8px 12px',
        },
        [theme.breakpoints.between('sm','md')]: {
            padding: '10px 65px',
        },
    },
    rightContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height:'100%',
        overflowX:'hidden',
        overflowY:'auto',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
        },
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#cfd6e4',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f3f5f9',
        },
    },
    slidesContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flex: '1 1 auto',
        minHeight: 0,
        position: 'relative',
        textAlign: 'center',
        overflowY: 'auto',
        overflowX: 'hidden',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#cfd6e4',
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#f3f5f9',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        marginBottom: '20px !important',
        marginTop: '20px',
        fontSize: '19px',
        paddingLeft:'20px',
        paddingRight:'20px',
        display: '-webkit-box',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
    },
    card: {
        marginBottom: '15px',
        backgroundColor: 'transparent',
        borderRadius: '10px',
        cursor: 'pointer',
        color: '#002060',
        boxShadow:'none',
    },
    cardContent: {
        color: '#002060',
        paddingBottom:'16px !important',
    },
    unitTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#EE6628',
        textAlign: 'center',
        padding: '10px',
    },
    lessonContainer: {
        paddingLeft: '10px',
        paddingRight:'10px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: 'rgba(238, 102, 40, 0.15)',
        },
    },
    sectionRow: {
        marginTop:'20px',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '5px 0',
        alignItems: 'center',
    },
    sectionSegmentRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '10px',
        width: '100%',
        minWidth: 0,
    },
    lessonRow: {
        marginTop:'0px',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '5px 0',
        alignItems: 'center',
    },
    viewButton: {
        backgroundColor: '#fff',
        color: '#0097B2',
        padding: '5px 15px',
        borderRadius: '4px',
        textTransform: 'none',
        fontWeight: 500,
        flexShrink: 0,
        minWidth: '72px',
        boxSizing: 'border-box',
        '&:hover': {
            backgroundColor: '#ef6528',
            color: '#fff',
            borderColor: '#ef6528',
        },
        transition: 'all 0.3s ease',
    },
    dropdownContainer: {
        paddingLeft: '20px',
        marginTop: '10px',
        borderLeft: '4px solid #ef6528',
    },
    sectionText: {
        fontWeight:'500',
        fontSize:'17px',
        color: '#002060',
        // fontWeight: 'bold',
    },
    selectedViewButton: {
        backgroundColor: '#c05615',
        '&:hover': {
            backgroundColor: '#af4d13',
        },
    },
    Button: {
        backgroundColor: '#ef6528',
        color: '#fff',
        marginTop: '20px',
        '&:hover': {
            backgroundColor: '#e44d1f',
        },
    },
    lessonTitle: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#333',
        paddingBottom: '50px',
    },
    sliderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '400px',
        backgroundColor: '#f3f1ec',
        borderRadius: '8px',
        position: 'relative',
    },
    slide: {
        display: 'none',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '20px',
        width: '100%',
    },
    activeSlide: {
        display: 'block',
    },
    arrowButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: 'transparent',
        border: 'none',
        color: '#ef6528',
        fontSize: '30px',
        cursor: 'pointer',
        zIndex: 10,
    },
    prevArrow: {
        left: '10px',
    },
    nextArrow: {
        right: '10px',
    },
    slider: {
        width: '90%',
        // marginBottom: '20px',
        height: 8,
        color: '#ef6528 !important',
    },
    dropdownOptions:{
        backgroundColor:'#fff',

    }
}));
export default useStyles;